// extracted by mini-css-extract-plugin
export var container = "_9n-0";
export var error = "_9n-9";
export var label = "_9n-5";
export var light = "_9n-6";
export var md = "_9n-3";
export var sm = "_9n-2";
export var thin = "_9n-8";
export var thinBold = "_9n-7";
export var vertical = "_9n-4";
export var xs = "_9n-1";